// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.CreateOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateOrderRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'IsTrial is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	isTrial!: boolean;

	@GandalfValidator({ notNull: { message: 'Location Id is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfProperty({ designType: Number })
	orderProcessorConfigId!: number | null;

	@GandalfConstantDecorator(constants.OrderType)
	@GandalfValidator({ notNull: { message: 'Order Type is required' } })
	@GandalfProperty({ designType: constants.OrderType, isRequired: true })
	orderType!: constants.OrderType;

	@GandalfValidator({ notNull: { message: 'Patient Id is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfProperty({ designType: Number })
	rxId!: number | null;

	@GandalfProperty({ designType: Number })
	vendorId!: number | null;

}
